import { motion } from 'framer-motion';
import { useApi } from '../hooks/useApi';
import './Progreso.css';

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 0) => ({ opacity: 1, y: 0, transition: { delay: i * 0.1, duration: 0.6 } }),
};

function ModuleBar({ label, value, max, icon, color }) {
  const pct = max ? Math.min(Math.round((parseInt(value) / max) * 100), 100) : 0;
  return (
    <motion.div
      className="module-bar"
      variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}
    >
      <div className="module-bar-header">
        <span className="module-icon">{icon}</span>
        <span className="module-label">{label}</span>
        <span className="module-status" style={{ color }}>
          {max ? `${value} / ${max}` : value}
        </span>
      </div>
      {max && (
        <div className="progress-bar-track" style={{ marginTop: '0.5rem' }}>
          <motion.div
            className="progress-bar-fill"
            style={{ background: `linear-gradient(90deg, ${color}99, ${color})` }}
            initial={{ width: 0 }}
            whileInView={{ width: `${pct}%` }}
            viewport={{ once: true }}
            transition={{ duration: 1.5, ease: [0.4, 0, 0.2, 1] }}
          />
        </div>
      )}
      {max && (
        <div className="module-pct">{pct}% completado</div>
      )}
    </motion.div>
  );
}

export default function Progreso() {
  const { data: progreso, loading } = useApi('/api/progreso');
  const { data: stats } = useApi('/api/stats');

  const pokedexNum = parseInt(progreso?.pokedex) || 0;

  return (
    <div className="page progreso-page">
      <div className="container">
        <motion.div
          className="page-header"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1>Índice de Desarrollo</h1>
          <p className="page-subtitle">Estado actual de la Biblia de Diseño de Veltara</p>
        </motion.div>

        {loading && <div className="loading-rune">Cargando estado del Instituto...</div>}

        {!loading && (
          <>
            <div className="progreso-grid">
              <ModuleBar
                label="Pokédex Regional"
                value={pokedexNum}
                max={127}
                icon="📖"
                color="var(--crystal-400)"
              />
              <ModuleBar
                label="Historia y Lore"
                value={progreso?.lore || 'Sin datos'}
                max={null}
                icon="📜"
                color="var(--amber-400)"
              />
              <ModuleBar
                label="Mecánica Cristal"
                value={progreso?.mecanica || 'Sin datos'}
                max={null}
                icon="⚙️"
                color="#a78bfa"
              />
            </div>

            {progreso?.notas && (
              <motion.div
                className="notas-card crystal-card"
                variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}
              >
                <h3>📝 Notas de Dirección</h3>
                <p>{progreso.notas}</p>
                <span className="notas-date">
                  Actualizado: {new Date(progreso.actualizadoEn).toLocaleDateString('es-ES')}
                </span>
              </motion.div>
            )}

            <div className="rune-divider"><span>◈ Estadísticas Globales ◈</span></div>

            <div className="global-stats">
              {[
                { label: 'Pokémon',    value: stats?.pokemon    || 0, icon: '📖', color: 'var(--crystal-400)' },
                { label: 'Archivos',   value: stats?.lore       || 0, icon: '📜', color: 'var(--amber-400)' },
                { label: 'Personajes', value: stats?.personajes || 0, icon: '⚔️',  color: '#f472b6' },
                { label: 'Arte',       value: stats?.arte       || 0, icon: '🖼️',  color: '#a78bfa' },
              ].map((s, i) => (
                <motion.div
                  key={s.label}
                  className="global-stat crystal-card"
                  variants={fadeUp} initial="hidden" whileInView="visible"
                  viewport={{ once: true }} custom={i}
                >
                  <span className="gs-icon">{s.icon}</span>
                  <motion.span
                    className="gs-value"
                    style={{ color: s.color }}
                    initial={{ opacity: 0, scale: 0.5 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.1 + 0.3, type: 'spring' }}
                  >
                    {s.value}
                  </motion.span>
                  <span className="gs-label">{s.label}</span>
                </motion.div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
